import { format } from "date-fns"
import { ptBR } from "date-fns/locale"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"

interface MessageBubbleProps {
  content: string
  senderName: string
  createdAt: string
  isOwnMessage: boolean
  messageType?: string
}

export const MessageBubble = ({ 
  content, 
  senderName, 
  createdAt, 
  isOwnMessage,
  messageType = "text"
}: MessageBubbleProps) => {
  const formatTime = (date: string) => {
    return format(new Date(date), "HH:mm", { locale: ptBR })
  }

  return (
    <div className={cn(
      "flex gap-2 mb-4",
      isOwnMessage ? "justify-end" : "justify-start"
    )}>
      {!isOwnMessage && (
        <Avatar className="h-8 w-8">
          <AvatarFallback className="text-xs bg-muted">
            {senderName.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
      )}
      
      <div className={cn(
        "flex flex-col max-w-[70%]",
        isOwnMessage ? "items-end" : "items-start"
      )}>
        {!isOwnMessage && (
          <span className="text-xs text-muted-foreground mb-1 px-2">
            {senderName}
          </span>
        )}
        
        <div className={cn(
          "rounded-lg px-3 py-2 text-sm",
          isOwnMessage 
            ? "bg-primary text-primary-foreground" 
            : "bg-muted text-muted-foreground",
          messageType === "system" && "bg-accent text-accent-foreground italic"
        )}>
          <p className="whitespace-pre-wrap">{content}</p>
          <span className={cn(
            "text-xs mt-1 block",
            isOwnMessage 
              ? "text-primary-foreground/70" 
              : "text-muted-foreground/70"
          )}>
            {formatTime(createdAt)}
          </span>
        </div>
      </div>
      
      {isOwnMessage && (
        <Avatar className="h-8 w-8">
          <AvatarFallback className="text-xs bg-primary text-primary-foreground">
            {senderName.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
      )}
    </div>
  )
}